var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.97,34.87V17.5c0-4.75-9.03-7.24-17.96-7.24s-17.96,2.49-17.96,7.24v17.38c-6.01,2.02-9.3,4.96-9.3,8.34,0,7.1,14.05,10.93,27.25,10.93s27.25-3.83,27.25-10.93c0-3.38-3.28-6.32-9.28-8.35h0ZM17.06,21.81c3.4,2.01,9.18,3.04,14.94,3.04s11.55-1.03,14.94-3.04v18.53c0,1.43-5.27,4.22-14.94,4.22s-14.94-2.78-14.94-4.22V21.81Zm14.94-8.53c9.67,0,14.94,2.79,14.94,4.22s-5.27,4.32-14.94,4.32-14.94-2.89-14.94-4.32,5.27-4.22,14.94-4.22Zm0,37.83c-13.86,0-24.23-4.17-24.23-7.91,0-1.76,2.35-3.65,6.26-5.13v2.25c0,4.75,9.03,7.24,17.96,7.24s17.96-2.49,17.96-7.24v-2.25c3.91,1.48,6.26,3.37,6.26,5.13,.02,3.73-10.34,7.91-24.21,7.91h0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHat);
export default __webpack_public_path__ + "static/media/icon_hat.51a16c2e.svg";
export { ForwardRef as ReactComponent };